import { useMutation, useQuery } from "react-query"
import DataService from '../../config/DataServices'
import { useToast } from "../../hooks/usetoast"
import { queryClient } from "../../config"

const { getRequest, putRequest, postRequest } = DataService()



export const useUserHistory = ({ id, page, size, searchText, sortField, userStatus, sortOrder, deleteStatus, type, country, recentLogin, kycStatus, cardStatus }) => {
    return useQuery({
        queryKey: ["user-history", id, page, size, searchText, sortField, sortOrder, userStatus, deleteStatus, type, country, recentLogin, kycStatus, cardStatus],
        queryFn: () => {
            let queryParams = `userId=${id}&page=${page}&size=${size}&search=${searchText}&sortOrder=${sortOrder}&sortField=${sortField}&country=${country}&recentLogin=${recentLogin}&kycStatus=${kycStatus}&cardStatus=${cardStatus}`;


            if (userStatus) {
                queryParams += `&userStatus=${userStatus}`;
            }
            if (deleteStatus) {
                queryParams += `&deleteStatus=${deleteStatus}`;
            }
            if (type) {
                queryParams += `&type=${type}`
            }

            return getRequest(`/users?${queryParams}`);
        }
    });
};

export const useUpdateDeleteStatus = () => {

    return useMutation({
        mutationFn: (data) => {
            return postRequest("/update-delete-status", { ...data })
        },

        onSuccess: success => {
            queryClient.refetchQueries('user-history')

        }
    })
}

export const InternalTransaction = ({ id, page, size, searchText, sortField, userId, sortOrder }) => {
    return useQuery({
        queryKey: ["Internaltransfer-history", id, page, size, searchText, sortField, userId, sortOrder],
        queryFn: () => {
            return getRequest(`/transfer-history?page=${page}&size=${size}&search=${searchText}&sortOrder=${sortOrder}&sortField=${sortField}&userId=${userId}`)
        }
    })
}

export const DepositTransaction = ({ id, page, size, searchText, sortField, userId, type, currency, network, sortOrder }) => {
    return useQuery({
        queryKey: ["Deposit-Transaction", id, page, size, searchText, sortField, userId, type, currency, network, sortOrder],
        queryFn: () => {
            return getRequest(`/user-transactions?page=${page}&size=${size}&search=${searchText}&sortOrder=${sortOrder}&sortField=${sortField}&userId=${userId}&txnType=${type}`)
        }
    })

}

export const SingleInternalTransaction = ({ id, page, size, searchText, sortField, userId, type, currency, network, sortOrder }) => {
    return useQuery({
        queryKey: ["Deposit-Transaction", id, page, size, searchText, sortField, userId, type, currency, network, sortOrder],
        queryFn: () => {
            return getRequest(`/transfer-history?page=${page}&size=${size}&search=${searchText}&sortOrder=${sortOrder}&sortField=${sortField}&userId=${userId}`)
        }
    })

}



export const WithdrawTransaction = ({ id, page, size, searchText, sortField, userId, type, currency, network, sortOrder }) => {
    return useQuery({
        queryKey: ["Withdraw-Transaction", id, page, size, searchText, sortField, userId, type, currency, network, sortOrder],
        queryFn: () => {
            return getRequest(`/user-transactions?page=${page}&size=${size}&search=${searchText}&sortOrder=${sortOrder}&sortField=${sortField}&userId=${userId}&type=Withdraw`)
        }
    })
}



export const ReferralTransaction = ({ id, page, size, searchText, sortField, userId, sortOrder }) => {
    return useQuery({
        queryKey: ["Referral-list", id, page, size, searchText, sortField, userId, sortOrder],
        queryFn: () => {
            return getRequest(`/referral-list?page=${page}&size=${size}&sortOrder=${sortOrder}&search=${searchText}&sortField=${sortField}&userId=${userId}`)
        }
    })
}


//Referral with level 

export const useGetReferralLevel = ({ id, userId, type, page, limit, level, size, searchText }) => {
    return useQuery({
        queryKey: ["level-list", id, page, size, searchText, userId, type, limit, level],
        queryFn: () => {
            return getRequest(`/grzwqdhsi?userId=${userId}&type=${type}&page=${page}&limit=${limit}&level=${level}&search=${searchText}`)
        }
    })
}

export const ReferralRewardTransaction = ({ id, page, size, searchText, sortField, sortOrder, userId }) => {
    return useQuery({
        queryKey: ["Referral-list", id, page, size, searchText, sortField, sortOrder, userId],
        queryFn: () => {
            return getRequest(`/users-referral-history?page=${page}&size=${size}&sortOrder=${sortOrder}&search=${searchText}&sortField=${sortField}&userId=${userId}`)
        }
    })
}

export const useSingleUserTransaction = ({ userId }) => {
    return useQuery({
        queryKey: ["SingleUser-Transaction", userId],
        queryFn: () => {
            return getRequest(`/user-dashboard?userId=${userId}`)
        }
    })
}


export const getOneUser = ({ id }) => {
    return getRequest(
        `/users/${id}`
    )
}

export const useSingleUserHistory = ({ id }) => {
    return useQuery({
        queryKey: ['single-users', id],
        queryFn: () => getOneUser({ id })
    })
}


export const useSupdateBlockstatus = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return putRequest("/update-block-status", data)
        },
        onSuccess: (variables) => {
            queryClient.refetchQueries(["user-history", variables.userId]);
            return toast.success("Status updated")
        }
    })
}

export const useGetTallyReport = ({ id, userId }) => {
    return useQuery({
        queryKey: ["tally-report", id, userId],
        queryFn: () => {
            return getRequest(`/get-user-audit-report/${id}`)
        }
    })
}

export const useViewUserPermission = () => {

    return useMutation({
        mutationFn: (data) => {
            return postRequest("/view-user-permission", data)
        },
        onSuccess: success => {
            queryClient.refetchQueries('user-history')

        }
    })
}

export const useUpdateUserAccess = () => {

    return useMutation({
        mutationFn: (data) => {
            return postRequest("/update-user-permission", { ...data })
        },

        onSuccess: success => {
            queryClient.refetchQueries('user-history')

        }
    })
}

export const useGetBlockedUsers = ({ id, page, size, searchText, sortField, sortOrder }) => {
    return useQuery({
        queryKey: ["blocked-users", id, page, size, searchText, sortField, sortOrder],
        queryFn: () => {
            return getRequest(`/userlsg-blocked-list?page=${page}&size=${size}&search=${searchText}&sortOrder=${sortOrder}&sortField=${sortField}`)
        }
    })
}

export const useUpdateUserBlock = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("/zugkgnjaui", data)
        },
        onSuccess: (variables) => {
            queryClient.refetchQueries(["blocked-users", variables.userId]);
            return toast.success("Status updated")
        }
    })
}

export const useExportUserList = () => {
    return useQuery({
        queryKey: ["user-export"],
        queryFn: () => {
            return getRequest('/export-user-list')
        }
    })
}

export const useLoginAsUser = () => {

    return useMutation({
        mutationFn: data => {
            return postRequest("/auth/abgdylyushgra", data)
        },
    })
}

export const useResendSumSubLink = () => {

    return useMutation({
        mutationFn: data => {
            return postRequest("/card/resend-sumsub-link", data)
        },
    })
}

export const useUpdatePostal = () => {

    return useMutation({
        mutationFn: data => {
            return postRequest("/card/update-postal-code", data)
        },
    })
}

export const useDisableTFA = () => {

    return useMutation({
        mutationFn: data => {
            return postRequest("/jgbjgswujhx", data)
        },
    })
}

export const useResendMail = () => {

    return useMutation({
        mutationFn: data => {
            return postRequest("/axcadegjls", data)
        },
    })
}


export const useGetReferLevels = ({ userId }) => {
    return useQuery({
        queryKey: ["user-refferal", userId],
        queryFn: () => {
            return getRequest(`/gershauiaft?userId=${userId}`)
        }
    })
}

export const useGetUserCashbackHistory = ({ id, page, size, searchText, sortField, sortOrder, type, level, userId }) => {
    return useQuery({
        queryKey: ["Cashback-history", id, page, size, searchText, sortField, sortOrder, type, level, userId],
        queryFn: () => {
            return getRequest(`/austeargakh?page=${page}&size=${size}&sortOrder=${sortOrder}&search=${searchText}&sortField=${sortField}&type=${type}&level=${level}&userId=${userId}`)
        }
    })
}